/**
 * Grabbed from here and there. Use a library instead?
 */
const types = {
  'application/dash+xml': ['mpd'],
  'application/ogg': ['ogx'],
  'application/vnd.apple.mpegurl': ['m3u8'],
  'audio/flac': ['flac'],
  'audio/midi': ['mid', 'midi', 'kar', 'rmi'],
  'audio/mp4': ['mp4a', 'm4a'],
  'audio/mpeg': ['mpga', 'mp2', 'mp2a', 'mp3', 'm2a', 'm3a'],
  'audio/ogg': ['oga', 'ogg', 'spx'],
  'audio/ogg; codecs=opus': ['opus'],
  'audio/wav': ['wav'],
  'audio/webm': ['weba'],
  'audio/x-matroska': ['mka'],
  'audio/x-mpegurl': ['m3u'],
  'video/3gpp': ['3gp'],
  'video/3gpp2': ['3g2'],
  'video/mp4': ['mp4', 'mp4v', 'mpg4'],
  'video/mpeg': ['mpeg', 'mpg', 'mpe', 'm1v', 'm2v'],
  'video/ogg': ['ogv'],
  'video/quicktime': ['qt', 'mov'],
  'video/webm': ['webm'],
  'video/x-f4v': ['f4v'],
  'video/x-fli': ['fli'],
  'video/x-flv': ['flv'],
  'video/x-m4v': ['m4v'],
  'video/x-matroska': ['mkv', 'mk3d', 'mks']
};
function isHlsMediaType(mediaType) {
  return mediaType.type === 'application/vnd.apple.mpegurl';
}
function isAudioOnlyMediaType(mediaType) {
  return mediaType.type.startsWith('audio/');
}
function guessMediaTypeOfUrl(url) {
  const extension = getFileExtensionOfUrl(url);
  return extension ? guessMediaType(extension) : undefined;
}
function getFileExtensionOfUrl(url) {
  const m = /\.(\w{2,4})(\?.*)?(#.*)?$/.exec(url);
  return m ? m[1] : undefined;
}
function guessMediaType(extension) {
  const ext = extension.replace(/^\./, '').toLowerCase();
  const type = Object.keys(types).find(mimeType => {
    return types[mimeType].includes(ext);
  });

  if (type) {
    return {
      type
    };
  }
}
function parseMediaTypeString(mediaType) {
  const m = /^(\w+\/[\w-.+]+)(?:.*;\s*codecs=([^;]+))?/.exec(mediaType);

  if (m && m.length > 1) {
    const _mediaType = {
      type: m[1]
    };

    if (m.length > 2) {
      _mediaType.codecs = m[2];
    }

    return _mediaType;
  }
}
function toMediaTypeString(mediaType) {
  if (mediaType === undefined) {
    return '';
  }

  if (typeof mediaType === 'string') {
    return mediaType;
  }

  const parameter = mediaType.codecs ? `;codecs=${mediaType.codecs}` : '';
  return `${mediaType.type}${parameter}`;
}

export { isAudioOnlyMediaType as a, guessMediaType as b, guessMediaTypeOfUrl as g, isHlsMediaType as i, parseMediaTypeString as p, toMediaTypeString as t };
